export const performanceRoutes = {
  dashboard: "/performance/dashboard",
  goals: "/performance/goals",
  goalDetail: (goalId = ":goalId") => `/performance/goals/${goalId}`,
  checkins: "/performance/checkins",
  feedback: "/performance/feedback",
  feedbackDetail: (feedbackId = ":feedbackId") =>
    `/performance/feedback/${feedbackId}`,
  feedbackReceived: "/performance/feedback/received",
  competencies: "/performance/competencies",
  competencyCategories: "/performance/competencies/categories",
  campaigns: "/performance/360/campaigns",
  campaignDetail: (campaignId = ":campaignId") =>
    `/performance/360/campaigns/${campaignId}`,
  campaignReviews: "/performance/360/reviews",
  reviews: "/performance/reviews",
  reviewDetail: (reviewId = ":reviewId") => `/performance/reviews/${reviewId}`,
  calibrations: "/performance/calibrations",
  calibrationDetail: (id = ":id") => `/performance/calibrations/${id}`,
  analytics: "/performance/analytics",
  goalCycles: "/performance/masters/goal-cycles",
  feedbackTypes: "/performance/masters/feedback-types",
};

export default performanceRoutes;
